import React, { useState } from "react";
import Modalform from "../Formularz/Modalform";

import "./TreningP.css";
import MiniNav from "../../components/Navbar/MiniNav";

const TreningP = () => {
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <MiniNav />
            <div className="app__bg section__padding">
                <div className="app__ofertaa">
                    <div className="app__oferta-menu1">
                        <p className="app__menu_heading">Pakiet Basic</p>
                        <ul className="white">
                            <li>
                                Idealna Oferta przeznaczona dla osób które
                                zaczynaja swoją przygodę z treningiem
                            </li>
                            <li>konsultacja treningowa</li>
                            <li>
                                Bezpieczeństwo i kontrola nad poprawną techniką
                                wykonywanych ćwiczeń
                            </li>
                            <li>
                                Szybsze osiągnięcie Twoich celów sylwetkowych,
                                kondycyjnych czy zdrowotnych
                            </li>
                            <li>
                                Profesjonalne i praktyczne porady dotyczące
                                odpowiedniego żywienia
                            </li>
                            <li>Regularny kontakt i wsparcie trenera</li>
                            <li>
                                Możliwość wykupienia pojedyńczego treningu
                                personalnego, pakietu 5, 10 lub 20 treningów
                            </li>
                        </ul>
                        <div className="buttonmm">
                            <button
                                onClick={() => setOpenModal(true)}
                                type="button"
                                className="customm__buttomm"
                            >
                                Poznaj ofertę
                            </button>
                            <Modalform
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                            />
                        </div>
                    </div>

                    <div className="app__oferta-menu2">
                        <p
                            style={{
                                background: "red",
                                color: "white",
                                textAlign: "center",
                            }}
                        >
                            Najczęściej wybierany
                        </p>
                        <p className="app__menu_heading">Pakiet COMPLEX</p>
                        <ul className="white">
                            <li>
                                Pakiet stworzony dla osób, które chcą w sposób
                                kompleksowy zadbać o swoje zdrowie
                            </li>
                            <li>Konsultacja treningowo-dietetyczna</li>
                            <li>
                                Szybsze i łatwiejsze osiągnięcie Twoich celów
                                sylwetkowych, kondycyjnych czy zdrowotnych
                            </li>
                            <li>
                                Indywidualny plan treningowy dostosowany pod
                                Twój cel
                            </li>
                            <li>
                                Bezpieczeństwo i kontrola nad poprawną techniką
                                wykonywanych przez Ciebie ćwiczeń
                            </li>
                            <li>
                                Profesjonalne porady w kwestiach odpowiedniego
                                żywienia
                            </li>
                            <li>
                                Indywidualny jadłospis 7-dniowy dostosowany do
                                Twoich preferencji żywieniowych z możliwością
                                drobnych poprawek + lista zakupów
                            </li>
                            <li>Regularny kontakt i wsparcie trenera</li>
                            <li>
                                Raport z osiągniętych efektów i analiza postępów
                            </li>
                            <li>Pomiar na analizatorze składu ciała InBody</li>
                            <li>
                                Pakiet zawiera 10 lub 20 treningów personalnych
                            </li>
                        </ul>
                        <div className="buttonmm1">
                            <button
                                onClick={() => setOpenModal(true)}
                                type="button"
                                className="customm__buttomm"
                            >
                                Poznaj ofertę
                            </button>
                            <Modalform
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                            />
                        </div>
                    </div>

                    <div className="app__oferta-menu3">
                        <p className="app__menu_heading">Pakiet PREMIUM</p>
                        <ul className="white">
                            <li>
                                Oferta dla osob, ktore chcą osiągnąć jeszcze
                                więcej
                            </li>
                            <li>Konsultacja treningowo-dietetyczna</li>
                            <li>
                                Szybsze i łatwiejsze osiągnięcie Twoich celów
                                sylwetkowych, kondycyjnych czy zdrowotnych
                            </li>
                            <li>
                                Bezpieczeństwo i kontrola nad poprawną techniką
                                wykonywanych przez Ciebie ćwiczeń
                            </li>
                            <li>
                                Indywidualny plan treningowy dostosowany pod
                                Twój cel
                            </li>
                            <li>
                                Profesjonalne porady w kwestiach odpowiedniego
                                żywienia
                            </li>
                            <li>Regularny kontakt i wsparcie trenera</li>
                            <li>
                                Raport z osiągniętych efektów <br/>i analiza postępów
                            </li>
                            <li>
                                Możliwość pomiaru na analizatorze składu ciała
                                InBody
                            </li>
                            <li>
                                Spersonalizowany 10-dniowy jadłospis dostosowany
                                do Twoich preferencji żywieniowych z możliwością
                                wprowadzania nieograniczonych poprawek <br />+ lista
                                zakupów
                            </li>
                            <li>Pakiet zawiera 20 treningów personalnych</li>
                        </ul>
                        <div className="buttonmm2">
                            <button
                                onClick={() => setOpenModal(true)}
                                type="button"
                                className="customm__buttomm"
                            >
                                Poznaj ofertę
                            </button>
                            <Modalform
                                open={openModal}
                                onClose={() => setOpenModal(false)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TreningP;
